import type React from "react";
import { Slider, SliderThumb, styled, type SliderProps } from "~/common/mui";
import ArrowsOutward from "~/common/mui/icons/ArrowsOutward";

const StyledSlider = styled(Slider)(({ theme }) => ({
  "& .MuiSlider-track": {
    backgroundColor: theme.palette.primary.main,
  },
  "& .MuiSlider-rail": {
    backgroundColor: theme.palette.primary.container,
    opacity: 1,
  },
  "& .MuiSlider-thumb": {
    height: 40,
    width: 40,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
}));

const ThumbIcon = styled(ArrowsOutward)(({ theme }) => ({
  color: theme.palette.common.white,
}));

export type ScrollSliderProps = SliderProps;

/**
 * A customized MUI Slider for scroll/zoom controls.
 * Features a large thumb with an ArrowsOutward icon.
 */
export const ScrollSlider = (props: ScrollSliderProps) => {
  return (
    <StyledSlider
      {...props}
      slots={{
        thumb: ThumbComponent,
        ...props.slots,
      }}
    />
  );
};

const ThumbComponent = (props: React.HTMLAttributes<HTMLSpanElement>) => {
  const { children, ...other } = props;
  return (
    <SliderThumb {...other}>
      {children}
      <ThumbIcon />
    </SliderThumb>
  );
};
